import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { postPageview } from "@/lib/api";

// Anonymous first-party page views: a per-tab session id (no cookies, no IP stored).
const KEY = "lumiere_session";

const sessionId = () => {
  let id = window.sessionStorage.getItem(KEY);
  if (!id) {
    id = (window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`).slice(0, 64);
    window.sessionStorage.setItem(KEY, id);
  }
  return id;
};

export const usePageviews = () => {
  const { pathname, search } = useLocation();
  const last = useRef(null);
  useEffect(() => {
    if (typeof window === "undefined" || pathname.startsWith("/admin") || last.current === pathname) return;
    const first = last.current === null;
    last.current = pathname;
    const params = new URLSearchParams(search);
    postPageview({
      path: pathname,
      session_id: sessionId(),
      referrer: first ? document.referrer || null : null,
      utm_source: params.get("utm_source") || null,
      utm_campaign: params.get("utm_campaign") || null,
    }).catch(() => {});
  }, [pathname, search]);
};
